import { createContext } from "react";
export var SidebarMenuItemContext = /*#__PURE__*/ createContext(null);
